module.exports = "/images/Balck light  Golf.svg?3f4505aeaefad2147b7a797552737f58";